import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormControlBase } from './form-control-base';
import { FormGroupService } from './dynamic-form.service';
import { Location } from '@angular/common';

@Component({
    selector: 'dynamic-form',
    template: require('./dynamic-form.html'),
    providers: [FormGroupService]
})
export class DynamicFormComponent implements OnInit {

    @Input() fields: FormControlBase<any>[] = [];
    @Input() hasFooter: boolean = true;
    @Input() disableForm: boolean = false;
    @Input() hideUndo: boolean = false;
    @Output() hasForm = new EventEmitter();
    @Output() submitForm = new EventEmitter();
    @Output() revertForm = new EventEmitter();
    @Output() selectedValueDataChanged = new EventEmitter<{id: string, value: string, selectedIndex: string}>();
    public form: FormGroup;
    public submitted: Boolean;

    constructor(
        private formGroupService: FormGroupService,
        public location: Location
    ) {
        this.submitted = false;
        
     }

    submit(){
        this.submitted = true;
        if(this.form.valid){
            this.submitForm.next();
        }
    }

    ngOnInit() {
        if (this.disableForm) {
            this.fields.forEach(x => x.disabled = true);
        }
        this.form = this.formGroupService.toFormGroup(this.fields);
        this.hasForm.next();
    }

    onValueChanged(selectedData: {id: string, value: string, selectedIndex: string}){
        this.selectedValueDataChanged.emit(selectedData);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dynamic-form/dynamic-form.component.ts